export default "__VITE_ASSET__d0dae199__"